import { MetadataStore } from 'breeze-client';

import { Ach } from './ach';
import { AchAttachment } from './ach-attachment';
import { AchNote } from './ach-note';
import { AchTransaction } from './ach-transaction';
import { AssemblyJig } from './assembly-jig';
import { AssemblyJigLock } from './assembly-jig-lock';
import { AssemblyJigMember } from './assembly-jig-member';
import { AssemblyJigNote } from './assembly-jig-note';
import { AssemblySchedule } from './assembly-schedule';
import { AuditLog } from './audit-log';
import { AuthRefreshToken } from './auth-refresh-token';
import { BuildAssembly } from './build-assembly';
import { BuildAssemblyDetail } from './build-assembly-detail';
import { BuildAssemblyDetailPart } from './build-assembly-detail-part';
import { BuildAssemblyStatus } from './build-assembly-status';
import { Confirmation } from './confirmation';
import { ConfirmationMessage } from './confirmation-message';
import { ConfirmationPaymentMethod } from './confirmation-payment-method';
import { ConfirmationType } from './confirmation-type';
import { Contact } from './contact';
import { ContactLog } from './contact-log';
import { ContactMethod } from './contact-method';
import { ContactRole } from './contact-role';
import { ContactType } from './contact-type';
import { CreditCard } from './credit-card';
import { Customer } from './customer';
import { CustomerReview } from './customer-review';
import { Dealer } from './dealer';
import { DealerAttachment } from './dealer-attachment';
import { DealerTerm } from './dealer-term';
import { Delivery } from './delivery';
import { DeliveryDriver } from './delivery-driver';
import { DeliveryOption } from './delivery-option';
import { DeliveryStack } from './delivery-stack';
import { DeliveryTrailer } from './delivery-trailer';
import { DeliveryTransportPlate } from './delivery-transport-plate';
import { DeliveryTruck } from './delivery-truck';
import { EmailAddress } from './email-address';
import { EmailAttachment } from './email-attachment';
import { EmailMessage } from './email-message';
import { EmailTemplate } from './email-template';
import { EventLog } from './event-log';
import { ExpenseReport } from './expense-report';
import { ExpenseReportLine } from './expense-report-line';
import { ExpenseReportLineAttachment } from './expense-report-line-attachment';
import { ExpenseType } from './expense-type';
import { FeeType } from './fee-type';
import { HoldNote } from './hold-note';
import { InventoryProjection } from './inventory-projection';
import { InventoryProjectionLine } from './inventory-projection-line';
import { InventoryProjectionLinePart } from './inventory-projection-line-part';
import { Invoice } from './invoice';
import { InvoiceAttachment } from './invoice-attachment';
import { InvoiceFee } from './invoice-fee';
import { InvoiceLine } from './invoice-line';
import { InvoiceNote } from './invoice-note';
import { InvoicePaymentMethod } from './invoice-payment-method';
import { InvoiceStatus } from './invoice-status';
import { LookupValue } from './lookup-value';
import { Note } from './note';
import { Order } from './order';
import { OrderAchPayment } from './order-ach-payment';
import { OrderAttachment } from './order-attachment';
import { OrderLine } from './order-line';
import { OrderLineDetail } from './order-line-detail';
import { OrderLineDetailNote } from './order-line-detail-note';
import { OrderLineDetailPart } from './order-line-detail-part';
import { OrderLineStatus } from './order-line-status';
import { OrderPaymentMethod } from './order-payment-method';
import { OrderStatus } from './order-status';
import { OrderType } from './order-type';
import { PackingSlip } from './packing-slip';
import { PackingSlipAttachment } from './packing-slip-attachment';
import { Part } from './part';
import { PartAlias } from './part-alias';
import { PartAliasType } from './part-alias-type';
import { PartAttachment } from './part-attachment';
import { PartBulkEdit } from './part-bulk-edit';
import { PartConfigAttachment } from './part-config-attachment';
import { PartConfigAxle } from './part-config-axle';
import { PartConfigBrake } from './part-config-brake';
import { PartConfigCrossArm } from './part-config-cross-arm';
import { PartConfigGeneralSetting } from './part-config-general-setting';
import { PartConfigModelSize } from './part-config-model-size';
import { PartConfigModelType } from './part-config-model-type';
import { PartConfigOption } from './part-config-option';
import { PartConfigPlaceQuantity } from './part-config-place-quantity';
import { PartConfigPlaceQuantityCrossArmLink } from './part-config-place-quantity-cross-arm-link';
import { PartConfigSizeLink } from './part-config-size-link';
import { PartConfigSuspension } from './part-config-suspension';
import { PartConfigSuspensionTireLink } from './part-config-suspension-tire-link';
import { PartConfigTire } from './part-config-tire';
import { PartConfigWinchStand } from './part-config-winch-stand';
import { PartConfigWinchStandOption } from './part-config-winch-stand-option';
import { PartConfigWinchStandOptionLink } from './part-config-winch-stand-option-link';
import { PartConfiguration } from './part-configuration';
import { PartConfigurationLine } from './part-configuration-line';
import { PartLink } from './part-link';
import { PartOption } from './part-option';
import { PartPartServiceChargeLink } from './part-part-service-charge-link';
import { PartPartType } from './part-part-type';
import { PartPurchase } from './part-purchase';
import { PartPurchaseAttachment } from './part-purchase-attachment';
import { PartServiceCharge } from './part-service-charge';
import { PartType } from './part-type';
import { Payment } from './payment';
import { PaymentCredit } from './payment-credit';
import { PaymentCreditType } from './payment-credit-type';
import { PaymentLine } from './payment-line';
import { PaymentLineType } from './payment-line-type';
import { Photo } from './photo';
import { PricingTier } from './pricing-tier';
import { PurchaseOrder } from './purchase-order';
import { PurchaseOrderAttachment } from './purchase-order-attachment';
import { PurchaseOrderInvoice } from './purchase-order-invoice';
import { PurchaseOrderInvoiceLine } from './purchase-order-invoice-line';
import { PurchaseOrderLine } from './purchase-order-line';
import { PurchaseOrderLineItem } from './purchase-order-line-item';
import { PurchaseOrderLineReceiving } from './purchase-order-line-receiving';
import { PurchaseOrderLineStatus } from './purchase-order-line-status';
import { PurchaseOrderPickUp } from './purchase-order-pick-up';
import { PurchaseOrderPickUpLine } from './purchase-order-pick-up-line';
import { PurchaseOrderShipAddress } from './purchase-order-ship-address';
import { PurchaseOrderStatus } from './purchase-order-status';
import { QuickBooksAccount } from './quick-books-account';
import { Role } from './role';
import { SalesRep } from './sales-rep';
import { Setting } from './setting';
import { ShipAddress } from './ship-address';
import { StateTaxExemption } from './state-tax-exemption';
import { User } from './user';
import { UserRole } from './user-role';
import { Vendor } from './vendor';
import { VendorPaymentMethod } from './vendor-payment-method';
import { VendorTerm } from './vendor-term';
import { Vin } from './vin';
import { WarrantyRegistration } from './warranty-registration';

export class GenesisTrailersRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('Ach', Ach);
        metadataStore.registerEntityTypeCtor('AchAttachment', AchAttachment);
        metadataStore.registerEntityTypeCtor('AchNote', AchNote);
        metadataStore.registerEntityTypeCtor('AchTransaction', AchTransaction);
        metadataStore.registerEntityTypeCtor('AssemblyJig', AssemblyJig);
        metadataStore.registerEntityTypeCtor('AssemblyJigLock', AssemblyJigLock);
        metadataStore.registerEntityTypeCtor('AssemblyJigMember', AssemblyJigMember);
        metadataStore.registerEntityTypeCtor('AssemblyJigNote', AssemblyJigNote);
        metadataStore.registerEntityTypeCtor('AssemblySchedule', AssemblySchedule);
        metadataStore.registerEntityTypeCtor('AuditLog', AuditLog);
        metadataStore.registerEntityTypeCtor('AuthRefreshToken', AuthRefreshToken);
        metadataStore.registerEntityTypeCtor('BuildAssembly', BuildAssembly);
        metadataStore.registerEntityTypeCtor('BuildAssemblyDetail', BuildAssemblyDetail);
        metadataStore.registerEntityTypeCtor('BuildAssemblyDetailPart', BuildAssemblyDetailPart);
        metadataStore.registerEntityTypeCtor('BuildAssemblyStatus', BuildAssemblyStatus);
        metadataStore.registerEntityTypeCtor('Confirmation', Confirmation);
        metadataStore.registerEntityTypeCtor('ConfirmationMessage', ConfirmationMessage);
        metadataStore.registerEntityTypeCtor('ConfirmationPaymentMethod', ConfirmationPaymentMethod);
        metadataStore.registerEntityTypeCtor('ConfirmationType', ConfirmationType);
        metadataStore.registerEntityTypeCtor('Contact', Contact);
        metadataStore.registerEntityTypeCtor('ContactLog', ContactLog);
        metadataStore.registerEntityTypeCtor('ContactMethod', ContactMethod);
        metadataStore.registerEntityTypeCtor('ContactRole', ContactRole);
        metadataStore.registerEntityTypeCtor('ContactType', ContactType);
        metadataStore.registerEntityTypeCtor('CreditCard', CreditCard);
        metadataStore.registerEntityTypeCtor('Customer', Customer);
        metadataStore.registerEntityTypeCtor('CustomerReview', CustomerReview);
        metadataStore.registerEntityTypeCtor('Dealer', Dealer);
        metadataStore.registerEntityTypeCtor('DealerAttachment', DealerAttachment);
        metadataStore.registerEntityTypeCtor('DealerTerm', DealerTerm);
        metadataStore.registerEntityTypeCtor('Delivery', Delivery);
        metadataStore.registerEntityTypeCtor('DeliveryDriver', DeliveryDriver);
        metadataStore.registerEntityTypeCtor('DeliveryOption', DeliveryOption);
        metadataStore.registerEntityTypeCtor('DeliveryStack', DeliveryStack);
        metadataStore.registerEntityTypeCtor('DeliveryTrailer', DeliveryTrailer);
        metadataStore.registerEntityTypeCtor('DeliveryTransportPlate', DeliveryTransportPlate);
        metadataStore.registerEntityTypeCtor('DeliveryTruck', DeliveryTruck);
        metadataStore.registerEntityTypeCtor('EmailAddress', EmailAddress);
        metadataStore.registerEntityTypeCtor('EmailAttachment', EmailAttachment);
        metadataStore.registerEntityTypeCtor('EmailMessage', EmailMessage);
        metadataStore.registerEntityTypeCtor('EmailTemplate', EmailTemplate);
        metadataStore.registerEntityTypeCtor('EventLog', EventLog);
        metadataStore.registerEntityTypeCtor('ExpenseReport', ExpenseReport);
        metadataStore.registerEntityTypeCtor('ExpenseReportLine', ExpenseReportLine);
        metadataStore.registerEntityTypeCtor('ExpenseReportLineAttachment', ExpenseReportLineAttachment);
        metadataStore.registerEntityTypeCtor('ExpenseType', ExpenseType);
        metadataStore.registerEntityTypeCtor('FeeType', FeeType);
        metadataStore.registerEntityTypeCtor('HoldNote', HoldNote);
        metadataStore.registerEntityTypeCtor('InventoryProjection', InventoryProjection);
        metadataStore.registerEntityTypeCtor('InventoryProjectionLine', InventoryProjectionLine);
        metadataStore.registerEntityTypeCtor('InventoryProjectionLinePart', InventoryProjectionLinePart);
        metadataStore.registerEntityTypeCtor('Invoice', Invoice);
        metadataStore.registerEntityTypeCtor('InvoiceAttachment', InvoiceAttachment);
        metadataStore.registerEntityTypeCtor('InvoiceFee', InvoiceFee);
        metadataStore.registerEntityTypeCtor('InvoiceLine', InvoiceLine);
        metadataStore.registerEntityTypeCtor('InvoiceNote', InvoiceNote);
        metadataStore.registerEntityTypeCtor('InvoicePaymentMethod', InvoicePaymentMethod);
        metadataStore.registerEntityTypeCtor('InvoiceStatus', InvoiceStatus);
        metadataStore.registerEntityTypeCtor('LookupValue', LookupValue);
        metadataStore.registerEntityTypeCtor('Note', Note);
        metadataStore.registerEntityTypeCtor('Order', Order);
        metadataStore.registerEntityTypeCtor('OrderAchPayment', OrderAchPayment);
        metadataStore.registerEntityTypeCtor('OrderAttachment', OrderAttachment);
        metadataStore.registerEntityTypeCtor('OrderLine', OrderLine);
        metadataStore.registerEntityTypeCtor('OrderLineDetail', OrderLineDetail);
        metadataStore.registerEntityTypeCtor('OrderLineDetailNote', OrderLineDetailNote);
        metadataStore.registerEntityTypeCtor('OrderLineDetailPart', OrderLineDetailPart);
        metadataStore.registerEntityTypeCtor('OrderLineStatus', OrderLineStatus);
        metadataStore.registerEntityTypeCtor('OrderPaymentMethod', OrderPaymentMethod);
        metadataStore.registerEntityTypeCtor('OrderStatus', OrderStatus);
        metadataStore.registerEntityTypeCtor('OrderType', OrderType);
        metadataStore.registerEntityTypeCtor('PackingSlip', PackingSlip);
        metadataStore.registerEntityTypeCtor('PackingSlipAttachment', PackingSlipAttachment);
        metadataStore.registerEntityTypeCtor('Part', Part);
        metadataStore.registerEntityTypeCtor('PartAlias', PartAlias);
        metadataStore.registerEntityTypeCtor('PartAliasType', PartAliasType);
        metadataStore.registerEntityTypeCtor('PartAttachment', PartAttachment);
        metadataStore.registerEntityTypeCtor('PartBulkEdit', PartBulkEdit);
        metadataStore.registerEntityTypeCtor('PartConfigAttachment', PartConfigAttachment);
        metadataStore.registerEntityTypeCtor('PartConfigAxle', PartConfigAxle);
        metadataStore.registerEntityTypeCtor('PartConfigBrake', PartConfigBrake);
        metadataStore.registerEntityTypeCtor('PartConfigCrossArm', PartConfigCrossArm);
        metadataStore.registerEntityTypeCtor('PartConfigGeneralSetting', PartConfigGeneralSetting);
        metadataStore.registerEntityTypeCtor('PartConfigModelSize', PartConfigModelSize);
        metadataStore.registerEntityTypeCtor('PartConfigModelType', PartConfigModelType);
        metadataStore.registerEntityTypeCtor('PartConfigOption', PartConfigOption);
        metadataStore.registerEntityTypeCtor('PartConfigPlaceQuantity', PartConfigPlaceQuantity);
        metadataStore.registerEntityTypeCtor('PartConfigPlaceQuantityCrossArmLink', PartConfigPlaceQuantityCrossArmLink);
        metadataStore.registerEntityTypeCtor('PartConfigSizeLink', PartConfigSizeLink);
        metadataStore.registerEntityTypeCtor('PartConfigSuspension', PartConfigSuspension);
        metadataStore.registerEntityTypeCtor('PartConfigSuspensionTireLink', PartConfigSuspensionTireLink);
        metadataStore.registerEntityTypeCtor('PartConfigTire', PartConfigTire);
        metadataStore.registerEntityTypeCtor('PartConfigWinchStand', PartConfigWinchStand);
        metadataStore.registerEntityTypeCtor('PartConfigWinchStandOption', PartConfigWinchStandOption);
        metadataStore.registerEntityTypeCtor('PartConfigWinchStandOptionLink', PartConfigWinchStandOptionLink);
        metadataStore.registerEntityTypeCtor('PartConfiguration', PartConfiguration);
        metadataStore.registerEntityTypeCtor('PartConfigurationLine', PartConfigurationLine);
        metadataStore.registerEntityTypeCtor('PartLink', PartLink);
        metadataStore.registerEntityTypeCtor('PartOption', PartOption);
        metadataStore.registerEntityTypeCtor('PartPartServiceChargeLink', PartPartServiceChargeLink);
        metadataStore.registerEntityTypeCtor('PartPartType', PartPartType);
        metadataStore.registerEntityTypeCtor('PartPurchase', PartPurchase);
        metadataStore.registerEntityTypeCtor('PartPurchaseAttachment', PartPurchaseAttachment);
        metadataStore.registerEntityTypeCtor('PartServiceCharge', PartServiceCharge);
        metadataStore.registerEntityTypeCtor('PartType', PartType);
        metadataStore.registerEntityTypeCtor('Payment', Payment);
        metadataStore.registerEntityTypeCtor('PaymentCredit', PaymentCredit);
        metadataStore.registerEntityTypeCtor('PaymentCreditType', PaymentCreditType);
        metadataStore.registerEntityTypeCtor('PaymentLine', PaymentLine);
        metadataStore.registerEntityTypeCtor('PaymentLineType', PaymentLineType);
        metadataStore.registerEntityTypeCtor('Photo', Photo);
        metadataStore.registerEntityTypeCtor('PricingTier', PricingTier);
        metadataStore.registerEntityTypeCtor('PurchaseOrder', PurchaseOrder);
        metadataStore.registerEntityTypeCtor('PurchaseOrderAttachment', PurchaseOrderAttachment);
        metadataStore.registerEntityTypeCtor('PurchaseOrderInvoice', PurchaseOrderInvoice);
        metadataStore.registerEntityTypeCtor('PurchaseOrderInvoiceLine', PurchaseOrderInvoiceLine);
        metadataStore.registerEntityTypeCtor('PurchaseOrderLine', PurchaseOrderLine);
        metadataStore.registerEntityTypeCtor('PurchaseOrderLineItem', PurchaseOrderLineItem);
        metadataStore.registerEntityTypeCtor('PurchaseOrderLineReceiving', PurchaseOrderLineReceiving);
        metadataStore.registerEntityTypeCtor('PurchaseOrderLineStatus', PurchaseOrderLineStatus);
        metadataStore.registerEntityTypeCtor('PurchaseOrderPickUp', PurchaseOrderPickUp);
        metadataStore.registerEntityTypeCtor('PurchaseOrderPickUpLine', PurchaseOrderPickUpLine);
        metadataStore.registerEntityTypeCtor('PurchaseOrderShipAddress', PurchaseOrderShipAddress);
        metadataStore.registerEntityTypeCtor('PurchaseOrderStatus', PurchaseOrderStatus);
        metadataStore.registerEntityTypeCtor('QuickBooksAccount', QuickBooksAccount);
        metadataStore.registerEntityTypeCtor('Role', Role);
        metadataStore.registerEntityTypeCtor('SalesRep', SalesRep);
        metadataStore.registerEntityTypeCtor('Setting', Setting);
        metadataStore.registerEntityTypeCtor('ShipAddress', ShipAddress);
        metadataStore.registerEntityTypeCtor('StateTaxExemption', StateTaxExemption);
        metadataStore.registerEntityTypeCtor('User', User);
        metadataStore.registerEntityTypeCtor('UserRole', UserRole);
        metadataStore.registerEntityTypeCtor('Vendor', Vendor);
        metadataStore.registerEntityTypeCtor('VendorPaymentMethod', VendorPaymentMethod);
        metadataStore.registerEntityTypeCtor('VendorTerm', VendorTerm);
        metadataStore.registerEntityTypeCtor('Vin', Vin);
        metadataStore.registerEntityTypeCtor('WarrantyRegistration', WarrantyRegistration);
    }
}
